// extracted by mini-css-extract-plugin
export var badge = "_f6-2";
export var detailsPanel = "_f6-0";
export var resultRow = "_f6-1";